import React, { useState, useEffect, useRef } from "react";
import Axios from "axios"
import "../css/SidebarLayout.css";
import twitter_icon from "../assets/twitter-icon.png"
import instagram_icon from "../assets/instagram_icon.png"
import discord_icon from "../assets/discord-icon.png"
import goldcleats_ai_logo from "../assets/goldcleats_ai_logo.png"
import Logout from "./Logout";
import { Link } from "react-router-dom";

const SidebarLayout = ({ isExpanded, setIsExpanded, userId }) => {
    //const [isExpanded, setIsExpanded] = useState(true); // Toggle state

    const [searchHistory, setSearchHistory] = useState({
        Today: [],
        Yesterday: [],
        "Last Week": [],
        Older: [],
    });

    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    //const limit = 10; // Matches backend limit
    const sidebarRef = useRef(null); // ✅ Ref to track scroll position

    // 🔹 Define fetchSearchHistory Outside useEffect
    const fetchSearchHistory = async (newOffset) => {
        if (!hasMore) return;

        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("offset", newOffset); // Pagination
        formData.append("request", "searchHistory");
        formData.append("action", "searchHistoryAi");

        const API_URL = process.env.REACT_APP_BACKENDURL;

        try {
            const response = await Axios.post(API_URL, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
            });

            if (response.status === 200) {
                setSearchHistory((prevHistory) => ({
                    Today: [...prevHistory.Today, ...response.data.data.Today],
                    Yesterday: [...prevHistory.Yesterday, ...response.data.data.Yesterday],
                    "Last Week": [...prevHistory["Last Week"], ...response.data.data["Last Week"]],
                    Older: [...prevHistory.Older, ...response.data.data.Older],
                }));

                setOffset(response.data.offset); // Update next offset
                setHasMore(response.data.has_more); // Stop fetching if no more data
            }
        } catch (error) {
            console.error("Error fetching search history:", error);
        }
    };

    // 🔹 Initial Load on Mount
    useEffect(() => {
        if (!userId) return;
        fetchSearchHistory(0);
    }, [userId]);

    // 🔹 Infinite Scroll Handler
    useEffect(() => {
        const sidebarElement = sidebarRef.current;
        if (!sidebarElement) return;

        const handleScroll = () => {
            if (
                sidebarElement.scrollTop + sidebarElement.clientHeight >= sidebarElement.scrollHeight - 10
            ) {
                fetchSearchHistory(offset); // Fetch next batch when user reaches bottom
            }
        };

        sidebarElement.addEventListener("scroll", handleScroll);
        return () => sidebarElement.removeEventListener("scroll", handleScroll);
    }, [offset, hasMore]);

    return (
        <>
            <button className="toggle-btn toggle-btn-mobile " onClick={() => setIsExpanded(!isExpanded)}>
                <i className={`fa ${isExpanded ? "fa-angle-left" : "fa-angle-right"}`}></i> {/* Toggle Icon */}
            </button>

            <div className={`sidebar-container ${isExpanded ? "expanded" : "collapsed"}`}>
                {/* Sidebar */}

                <nav className="sidebar">
                    <button className="toggle-btn" onClick={() => setIsExpanded(!isExpanded)}>
                        <i className={`fa ${isExpanded ? "fa-angle-left" : "fa-angle-right"}`}></i> {/* Toggle Icon */}
                    </button>

                    {/* Sidebar Heading with Image */}
                    {isExpanded &&
                        <h4 className="sidebar-heading">
                            <Link to="/">
                                <img
                                    src={goldcleats_ai_logo}
                                    alt="GoldCleats Logo"
                                    className={`sidebar-logo ${isExpanded ? "expanded-logo" : "collapsed-logo"}`}
                                />
                            </Link>
                            {/* {isExpanded && "GoldCleats Studios"} */}
                        </h4>
                    }
                    <ul className="nav-links">
                        <li><a href="/"><i className="fa fa-globe"></i> {isExpanded && "Explore"}</a></li>
                        <li><Link to={`/pricing`}><i className="fa fa-user"></i> {isExpanded && "Account"}</Link></li>

                        {/* PlayerGpt - Coming Soon (Gray) */}
                        <li className="disabled-feature">
                            <a href="#">🕵️ {isExpanded && <div>playeragent.ai</div>}
                                {isExpanded && <><br /> <div className="coming-soon">Coming Soon</div></>}
                            </a>
                        </li>

                        {/* ScoutGpt - Coming Soon (Gray) */}
                        <li className="disabled-feature">
                            <a href="#">🔍 {isExpanded && "playerscout.ai"}
                                {isExpanded && <span className="coming-soon">Coming Soon</span>}
                            </a>
                        </li>

                        {/* ScoutGpt - Coming Soon (Gray) */}
                        <li className="disabled-feature">
                            <a href="#">📋 {isExpanded && "playermanager.ai"}
                                {isExpanded && <span className="coming-soon">Coming Soon</span>}
                            </a>
                        </li>

                    </ul>
                    <hr />

                    {isExpanded &&
                        <div className="sidebar-history" ref={sidebarRef}>

                            {Object.entries(searchHistory).map(([category, searches]) => (
                                searches.length > 0 && (
                                    <div key={category} className="history-category">
                                        <h6 className="category-title">{category}</h6>
                                        <div className="history-text">
                                            {searches.map((search, index) => (
                                                <Link key={index} to={`/?chat_id=${search.chat_id}`}><p key={index} className="history-item">{search.search_query.replace(/\\/g, "")}</p></Link>
                                            ))}
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    }

                    <div className="bottom-links">
                        {isExpanded && <h6 className="bottom-heading">Join our Community Today</h6>}
                        <a target="_blank" href="https://x.com/goldcleats" className="d-block text-dark mt-2">
                            <img
                                width={18}
                                src={twitter_icon}
                                alt="twitter icon"
                                className={`bottom-logo ${isExpanded ? "bottom-expanded-logo" : "bottom-collapsed-logo"}`}
                            /> {isExpanded && "Follow Us"}
                        </a>
                        <a target="_blank" href="https://discord.gg/7zwBUdw3Xf" className="d-block text-dark mt-2">
                            <img
                                width={18}
                                src={discord_icon}
                                alt="twitter icon"
                                className={`bottom-logo ${isExpanded ? "bottom-expanded-logo" : "bottom-collapsed-logo"}`}
                            />  {isExpanded && "Join Discord"}
                        </a>

                        <a target="_blank" href="https://www.instagram.com/goldcleats.ai/" className="d-block text-dark mt-2">
                            <img
                                width={18}
                                src={instagram_icon}
                                alt="Instagram icon"
                                className={`bottom-logo ${isExpanded ? "bottom-expanded-logo" : "bottom-collapsed-logo"}`}
                            />  {isExpanded && "Follow Us"}
                        </a>

                        {isExpanded && <Logout />}

                    </div>
                </nav>
            </div>
        </>
    );
};

export default SidebarLayout;
